module.exports = __webpack_public_path__ + "img/zoom-in-out.5f15f1bd.gif";